<template>
    <div class="node-properties-inner">
        <input v-model="properties.name" style="width: 200px">
    </div>
</template>

<script>
export default {
    props: {
        properties: { type: Object, required: true }
    }
}
</script>